import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import MDTypography from 'components/MDTypography';
import { useQueryData } from 'hook/useQueryData';
import { useGetApplicationInfoQuery } from 'services/applicationApi';
import { Copyright } from 'components/Copyright';
import { useAuth } from 'hook/useAuth';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

AboutDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default function AboutDialog({ open, onClose }) {
  const { data: appInfo } = useQueryData(useGetApplicationInfoQuery);
  const { formatMessage: msg } = useIntl();

  const { currentUser } = useAuth();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{appInfo?.app?.name}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div" id="alert-dialog-slide-description">
          <MDTypography variant="body2">{appInfo?.app?.description}</MDTypography>
          {currentUser.user && (
            <MDTypography variant="body2">
              {msg(
                { id: 'about.version' },
                { version: appInfo?.app?.version, buildNumber: appInfo?.app?.build?.number }
              )}
            </MDTypography>
          )}
          <Copyright align="left" sx={{ mt: 5 }} />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
